import Vue from "vue";
import Vuetify from "vuetify/lib";

import Ripple from "vuetify/lib/directives/ripple";
import VuetifyConfirm from "vuetify-confirm";
import VueRx from "vue-rx";
const vuetify = new Vuetify();
import VuejsClipper from "vuejs-clipper/dist/vuejs-clipper.umd";
import "vuejs-clipper/dist/vuejs-clipper.css";
import "@mdi/font/css/materialdesignicons.css";
import "@fortawesome/fontawesome-free/css/all.css";
import { customIcons } from "../customIcons/CustomIconsConfig";

Vue.use(VueRx);
Vue.use(VuejsClipper, {
  clipperBasic: true
});
Vue.use(VuetifyConfirm, { vuetify });
Vue.use(Vuetify, {
  // Workaround für Vuetifiy Bug
  directives: { Ripple }
});

export default new Vuetify({
  icons: {
    iconfont: "fa",
    values: customIcons
  }
});
